module.exports = __webpack_public_path__ + "static/media/mask-passo3.b52a0753.jpg";